import { render, staticRenderFns } from "./PlainForm.vue?vue&type=template&id=15ce2a92&scoped=true&"
import script from "./PlainForm.vue?vue&type=script&lang=js&"
export * from "./PlainForm.vue?vue&type=script&lang=js&"
import style0 from "./PlainForm.vue?vue&type=style&index=0&id=15ce2a92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce2a92",
  null
  
)

export default component.exports